module.exports = __webpack_public_path__ + "static/realtor-slack-comment-e8aaf6a18a2c7ac6830e59f6ce7d02b0.png";